import {
    FormControlLabel,
    Radio,
    RadioGroup
} from '@material-ui/core';
import * as React from 'react';
import {
    Field,
    FieldOption
} from '@models/field-builder/field';

export const FieldRadio = ({
                               id,
                               options,
                               setValueMethod,
                               value
                           }: Field) => {
    const handleChange = event => {
        event.preventDefault();
        if (!setValueMethod) {
            console.error(`No 'setValueMethod' found for the field: ${id}`);
            return;
        }
        setValueMethod(event.target.value);
    };
    return (
        <RadioGroup name={id}
                    onChange={handleChange}
                    value={value || ''}>
            {options && options.map((option: FieldOption) => (
                <FormControlLabel
                    key={option.key}
                    value={option.key}
                    control={<Radio/>}
                    label={option.label}
                />
            ))}
        </RadioGroup>
    );
};



// WEBPACK FOOTER //
// ./src/components/field-builder/field-radio.tsx